import Vue from "vue";
import Router from "vue-router";
import Layout from "@/layout";
import SinglePage from "@/layout/singlePage";
import Empty from "@/layout/empty";
import PopupWindow from "@/layout/popupWindow";

Vue.use(Router);

// 如首页和登录页和一些不用权限的公用页面
export const commontRouterMap = [
  {
    name: "login",
    path: "/login",
    component: () => import("@/views/login"),
    hidden: true, // 不在slider显示
  },
  {
    name: "wizard",
    path: "/wizard",
    id: "adv_setup_wizard",
    component: () => import("@/views/wizard/orbisetupWizard"),
    meta: { title: "wizard_head" },
  },
  {
    name: "conflict",
    path: "/conflict",
    id: "conflict",
    component: () => import("@/views/conflict"),
    meta: { title: "conflict" },
  },

  {
    name: "limit",
    path: "/limit",
    id: "limit",
    component: () => import("@/views/limit"),
    hidden: true,
  },
  {
    name: "license",
    path: "/license.htm",
    id: "license",
    component: () => import("@/views/license"),
    hidden: true,
  },
  {
    path: "/",
    component: PopupWindow,
    redirect: "/index",
    hidden: true,
    children: [
      {
        name: "statistics",
        path: "/statistics",
        id: "statistics",
        component: () => import("@/views/status/statistics"),
        hidden: true,
      },
      {
        name: "connectionStatus",
        path: "/connectionStatus",
        id: "connectionStatus",
        component: () => import("@/views/status/connectionStatus"),
        hidden: true,
      },
      {
        name: "orbiUpgradeVersionDetail",
        path: "/orbiUpgradeVersionDetail",
        id: "orbiUpgradeVersionDetail",
        component: () => import("@/views/orbiUpgrade/orbiUpgradeVersionDetail"),
        hidden: true,
      },
      {
        name: "raeLearn",
        path: "/raeLearn",
        id: "raeLearn",
        component: () => import("@/views/rae/raeLearn"),
        hidden: true,
      },
      {
        name: "raeBridge",
        path: "/raeBridge",
        id: "raeBridge",
        component: () => import("@/views/rae/raeBridge"),
        hidden: true,
      },
      {
        name: "DNS_ddns_status",
        path: "/DNS_ddns_status",
        id: "DNS_ddns_status",
        component: () => import("@/views/advSettings/ddnsStatus"),
        hidden: true,
      },
      {
        name: "trafficStatus",
        path: "/trafficStatus",
        id: "trafficStatus",
        component: () => import("@/views/advSettings/trafficStatus"),
        hidden: true,
      },
      {
        name: "vpn_windows_instruction",
        path: "/vpn_windows_instruction",
        id: "vpn_windows_instruction",
        component: () => import("@/views/advSettings/vpn_windows_instruction"),
        hidden: true,
      },
      {
        name: "vpn_mac_instruction",
        path: "/vpn_mac_instruction",
        id: "vpn_mac_instruction",
        component: () => import("@/views/advSettings/vpn_mac_instruction"),
        hidden: true,
      },
      {
        name: "vpn_iphone_instruction",
        path: "/vpn_iphone_instruction",
        id: "vpn_iphone_instruction",
        component: () => import("@/views/advSettings/vpn_iphone_instruction"),
        hidden: true,
      },
      {
        name: "vpn_andriod_instruction",
        path: "/vpn_andriod_instruction",
        id: "vpn_andriod_instruction",
        component: () => import("@/views/advSettings/vpn_andriod_instruction"),
        hidden: true,
      },
    ],
  },
  {
    path: "/",
    component: SinglePage,
    redirect: "/index",
    hidden: true,
    children: [
      {
        name: "logout",
        path: "logout",
        component: () => import("@/views/logout"),
        hidden: true, // 不在slider显示
      },
      {
        name: "multi",
        path: "multi",
        component: () => import("@/views/multi"),
        hidden: true, // 不在slider显示
      },
      {
        name: "debug.htm",
        path: "debug.htm",
        id: "debug",
        component: () => import("@/views/debug"),
        hidden: true,
      },
      {
        name: "unauth",
        path: "unauth",
        component: () => import("@/views/resetPassword"),
        hidden: true, // 不在slider显示
      },
      {
        name: "StringTableUpload",
        path: "StringTableUpload.html",
        id: "StringTableUpload",
        component: () => import("@/views/StringTableUpload"),
        hidden: true,
      },
      // {
      //   name: "enableStringTable",
      //   path: "enable_string_table.html",
      //   id: "enable_string",
      //   component: () => import("@/views/enableStringTable"),
      //   hidden: true,
      // },
    ],
  },
  {
    name: "index",
    path: "/index",
    component: () => import("@/views/index"),
    hidden: true, // 不在slider显示
  },
  {
    path: "/basic",
    meta: { title: "basic_title" },
    component: Layout,
    redirect: "/basic/home",
    id: "basic_label",
    isTopMenu: true,
    children: [
      {
        name: "basicHome",
        path: "home",
        id: "home",
        component: () => import("@/views/basicHome"),
        meta: { title: "hom" },
      },
      {
        name: "basicInternet",
        path: "internet",
        id: "internet",
        component: () => import("@/views/setup/basicInternet"),
        meta: { title: "internet" },
        off_mode: ["ap", "bridge"],
      },
      {
        name: "basicWireless",
        path: "wireless",
        id: "wireless",
        component: () => import("@/views/wireless/basicWireless"),
        meta: { title: "wireless" },
        off_mode: ["bridge"],
      },
      {
        name: "basicAttached",
        path: "attached",
        id: "attached",
        component: () => import("@/views/admin/attached"),
        meta: { title: "attach_device" },
      },
      // {
      //   path: 'qos',
      //   id: 'basic_qos',
      //   meta: { title: 'home_net' },
      // },
      // {
      //   path: 'ready',
      //   id: 'basic_ready',
      //   meta: { title: 'readyshare' },
      // },
      {
        name: "basicGuestNetwork",
        path: "guestNetwork",
        id: "guest",
        component: () => import("@/views/wireless/basicGuest"),
        meta: { title: "wlan_mark_guest" },
        off_mode: ["bridge"],
      },
      {
        name: "basicAddSatellite",
        path: "addSatellite",
        id: "satellite",
        component: () => import("@/views/addSatellite"),
        meta: { title: "add_orbi_satellite" },
      },
    ],
  },
  {
    path: "/adv",
    meta: { title: "advanced_title" },
    id: "advanced_label",
    component: Layout,
    redirect: "/adv/home",
    isTopMenu: true,
    children: [
      {
        name: "advHome",
        path: "home",
        id: "adv_home",
        component: () => import("@/views/status/advHome"),
        meta: { title: "adv_home" },
      },
      {
        path: "setup",
        id: "setup_bt",
        meta: { title: "setup_head" },
        component: Empty,
        children: [
          {
            name: "internet",
            path: "internet",
            id: "adv_internet",
            //component: () => import("@/views/setup/internet"),
            component: () => import("@/views/setup/ipv4Internet"),
            meta: { title: "int_setup" },
            off_mode: ["ap", "bridge"],
          },
          {
            name: "wireless",
            path: "wireless",
            id: "adv_wireless",
            component: () => import("@/views/wireless/wireless"),
            meta: { title: "wls_setup" },
            off_mode: ["bridge"],
          },
          {
            name: "guestNetwork",
            path: "guestNetwork",
            id: "adv_guest",
            component: () => import("@/views/wireless/basicGuest"),
            meta: { title: "wlan_mark_guest" },
            off_mode: ["bridge"],
          },
          {
            name: "wan",
            path: "wan",
            id: "wan",
            component: () => import("@/views/setup/wan"),
            meta: { title: "wan_setup_head" },
            off_mode: ["ap", "bridge"],
          },
          {
            name: "lan",
            path: "lan",
            id: "lan",
            component: () => import("@/views/setup/lan"),
            meta: { title: "lan_mark_head" },
            off_mode: ["ap", "bridge"],
          },
          //{
          //  name: "qos",
          //  path: "qos",
          //  id: "qos",
          //  component: () => import("@/views/setup/qos"),
          //  meta: { title: "speedtest" },
          //  off_mode: ["bridge"],
          //},
          {
            name: "devname",
            path: "devname",
            id: "devname",
            component: () => import("@/views/setup/devname"),
            meta: { title: "edit_devname" },
            off_mode: ["ap"],
          },
        ],
      },
      {
        path: "security",
        id: "security_bt",
        meta: { title: "wlan_guest_security" },
        component: Empty,
        children: [
          {
            name: "accessControl",
            path: "accessControl",
            id: "access_control",
            component: () => import("@/views/security/accessControl"),
            meta: { title: "acc_control" },
            off_mode: ["bridge"],
          },
          {
            name: "blockSites",
            path: "blockSites",
            id: "block_site",
            component: () => import("@/views/security/blockSites"),
            meta: { title: "block_sites_head" },
            off_mode: ["ap", "bridge"],
          },
          {
            name: "blockServices",
            path: "blockServices",
            id: "block_service",
            component: () => import("@/views/security/blockServices"),
            meta: { title: "block_serv_head" },
            off_mode: ["ap", "bridge"],
          },
          {
            name: "schedule",
            path: "schedule",
            id: "schedule",
            component: () => import("@/views/security/schedule"),
            meta: { title: "schedule_head" },
            off_mode: ["bridge"],
          },
          {
            name: "email",
            path: "email",
            id: "email",
            component: () => import("@/views/security/email"),
            meta: { title: "email_head" },
            off_mode: ["bridge"],
          },
        ],
      },
      {
        path: "admin",
        id: "admin_bt",
        meta: { title: "admin" },
        component: Empty,
        children: [
          {
            name: "status",
            path: "status",
            id: "status",
            component: () => import("@/views/status/advHome"),
            meta: { title: "info_mark_head" },
          },
          {
            name: "logs",
            path: "logs",
            id: "log",
            component: () => import("@/views/admin/logs"),
            meta: { title: "logs_head" },
          },
          {
            name: "attached",
            path: "attached",
            id: "adv_attached",
            component: () => import("@/views/admin/attached"),
            meta: { title: "attach_device" },
          },
          {
            name: "backup",
            path: "backup",
            id: "bak_set",
            component: () => import("@/views/admin/backup"),
            meta: { title: "backup_head" },
          },
          {
            name: "setPassword",
            path: "setPassword",
            id: "passwd",
            component: () => import("@/views/admin/setPassword"),
            meta: { title: "passwd_head" },
          },
          {
            name: "ntpSettings",
            path: "ntpSettings",
            id: "ntp",
            component: () => import("@/views/admin/ntpSettings"),
            meta: { title: "ntp_setting" },
          },
          {
            name: "orbiUpgrade",
            path: "orbiUpgrade",
            id: "upgrade",
            component: () => import("@/views/orbiUpgrade/orbiUpgrade"),
            meta: { title: "firm_upgrade" },
          },
        ],
      },
      {
        path: "advSettings",
        id: "advanced_bt",
        meta: { title: "adv_setup" },
        component: Empty,
        children: [
          {
            name: "advWireless",
            path: "wireless",
            id: "wladv",
            component: () => import("@/views/wireless/advWireless"),
            meta: { title: "wlan_mark" },
          },
          {
            name: "rae",
            path: "rae",
            id: "advanced_rae",
            component: () => import("@/views/rae/rae"),
            meta: { title: "operation_mode_1" },
          },
          {
            name: "pfPt",
            path: "pfPt",
            id: "forwarding_triggering",
            component: () => import("@/views/advSettings/pfPt"),
            meta: { title: "port_forward_trigger_head" },
            off_mode: ["ap", "bridge"],
          },
          {
            name: "ddns",
            path: "ddns",
            id: "dns",
            component: () => import("@/views/advSettings/ddns"),
            meta: { title: "ddns_head" },
            off_mode: ["bridge"],
          },
          {
            name: "vpnService",
            path: "vpnService",
            id: "vpn",
            component: () => import("@/views/advSettings/vpnService"),
            meta: { title: "vpn_head" },
            off_mode: ["ap", "bridge"],
          },
          {
            name: "staticRoutes",
            path: "staticRoutes",
            id: "static",
            component: () => import("@/views/advSettings/staticRoutes"),
            meta: { title: "static_router_head" },
            off_mode: ["bridge"],
          },
          {
            name: "webManage",
            path: "webManage",
            id: "remote",
            component: () => import("@/views/advSettings/webManage"),
            meta: { title: "web_management" },
            off_mode: ["ap", "bridge"],
          },
          {
            name: "upnp",
            path: "upnp",
            id: "advanced_upnp",
            component: () => import("@/views/advSettings/upnp"),
            meta: { title: "upnp_head" },
            off_mode: ["ap", "bridge"],
          },
          {
            name: "ipv6",
            path: "ipv6",
            id: "ipv6",
            component: () => import("@/views/advSettings/ipv6"),
            meta: { title: "ipv6_head" },
            off_mode: ["ap", "bridge"],
          },
          {
            name: "traffic",
            path: "traffic",
            id: "traffic",
            component: () => import("@/views/advSettings/traffic"),
            meta: { title: "traffic_head" },
            off_mode: ["ap", "bridge"],
          },
          {
            name: "vlan",
            path: "vlan",
            id: "vlan",
            component: () => import("@/views/advSettings/vlan"),
            meta: { title: "vlan_head" },
            hide_mode: ["ap", "bridge"],
          },
        ],
      },
    ],
  },
  {
    path: "*",
    redirect: { name: "index" },
  },
];

export const developRouterMap = [
  {
    name: "develop",
    path: "/develop",
    component: () => import("@/views/develop"),
    children: [
      {
        name: "webpage",
        path: "webpage",
        component: () => import("@/views/develop/webpage"),
        meta: { title: "创建新页面" },
      },
      {
        name: "table",
        path: "table",
        component: () => import("@/views/develop/table"),
        meta: { title: "table表格" },
      },
      // {
      //   name: "mock",
      //   path: "mock",
      //   component: () => import("@/views/develop/mock"),
      //   meta: { title: "Mock" },
      // },
      // {
      //   name: "validate",
      //   path: "validate",
      //   component: () => import("@/views/develop/validate"),
      //   meta: { title: "有效性检查" },
      // },
      {
        name: "utils",
        path: "utils",
        component: () => import("@/views/develop/utils"),
        meta: { title: "公共函数" },
      },
      {
        name: "pattern",
        path: "pattern",
        component: () => import("@/views/develop/pattern"),
        meta: { title: "正则表达式" },
      },
    ],
  },
];

export function createRouter() {
  let map = commontRouterMap;
  if (process.env.NODE_ENV === "development") {
    map = commontRouterMap.concat(developRouterMap);
  }
  return new Router({
    mode: process.env.VUE_APP_ENV === "development" ? "hash" : "history",
    scrollBehavior: () => ({ y: 0 }),
    routes: map,
  });
}

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

const router = createRouter();

export default router;
